import { collection, doc, serverTimestamp, setDoc } from "firebase/firestore";
import { db } from "../firebase";

export function createTournamentEventId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `evt-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export async function sendTournamentEvent({
  eventId,
  eventType,
  tournamentId,
  tournamentName,
  teamId,
  teamName,
  userId,
  sessionId,
  location,
  source = "online",
  message = "",
}) {
  if (!tournamentId || !userId) {
    throw new Error("Missing tournamentId or userId for tournament event");
  }
  if (!eventType) {
    throw new Error("Missing eventType for tournament event");
  }

  const resolvedEventId = eventId || createTournamentEventId();
  const eventRef = doc(collection(db, "tournamentEvents"), resolvedEventId);
  await setDoc(eventRef, {
    eventId: resolvedEventId,
    eventType,
    eventVersion: 1,
    tournamentId,
    tournamentName: tournamentName || "",
    teamId: teamId || "",
    teamName: teamName || "",
    userId,
    sessionId: sessionId || "",
    location:
      location && typeof location.lat === "number" && typeof location.lng === "number"
        ? { lat: location.lat, lng: location.lng }
        : null,
    message: message || "",
    visibility: "leaderboard",
    status: "active",
    source,
    occurredAt: serverTimestamp(),
    createdAt: serverTimestamp(),
  });

  return resolvedEventId;
}

export async function sendTournamentGeofenceAlert({
  eventId,
  tournamentId,
  tournamentName,
  teamId,
  teamName,
  userId,
  sessionId,
  location,
  source = "online",
}) {
  return sendTournamentEvent({
    eventId,
    eventType: "tournament.geofence_breach",
    tournamentId,
    tournamentName,
    teamId,
    teamName,
    userId,
    sessionId,
    location,
    source,
    message: "TOURNAMENT AREA RESTRICTION BREACH",
  });
}
